import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { USE_CASES_NTH_USER_ONBOARDING } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

export const preloadUseCasesNthUserOnboardingState = () => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [
				// For the banner and cards
				USE_CASES_NTH_USER_ONBOARDING.SELECTED_TEMPLATES,
				USE_CASES_NTH_USER_ONBOARDING.VIEWED_AT,
				USE_CASES_NTH_USER_ONBOARDING.DISMISSED_HEADER,
				USE_CASES_NTH_USER_ONBOARDING.VIEWED_HEADER,
			],
		},
	});
};
